<template>
  <section class="steps-main">
    <div class="steps-main__bg" />
    <div class="steps-main__content">
      <div class="step-head">
        <div class="container">
          <div class="head-row">
            <div class="head-row__position">
              <i18n path="forms.formHeader" tag="h2">
                <span>{{ this.$i18n.t("contract.step") }}</span>
              </i18n>
            </div>
            <h1>{{ this.$i18n.t("contract.stepDescription") }}</h1>
            <img src="@/assets/head-paso2.svg" class="head-row__img" />
          </div>
        </div>
      </div>
      <div class="container">
        <div class="box-form">
          <v-row>
            <v-spacer />
            <v-col cols="12" xs="12" sm="12" md="12" lg="10" xl="10">
              <h2 class="text-header">{{ this.$i18n.t("contract.guide.first") }}</h2>
              <v-row>
                <v-spacer />
                <a @click="fetchPreview">{{ $i18n.t("contract.preview") }}</a>
                <v-spacer />
              </v-row>
              <br />
              <i18n path="contract.guide.second.main" tag="h2" class="text-guide">
                <span class="text-blue">{{ this.$i18n.t("contract.guide.second.id") }}</span>
                <span class="text-blue">{{ this.$i18n.t("contract.guide.second.serial") }}</span>
              </i18n>
              <br />
              <v-divider />
              <br />
              <v-form ref="form" v-model="valid">
                <div class="row-form">
                  <!-- UPLOAD -->
                  <div class="col-form" v-if="isUploading">
                    <div class="col-form__item">
                      <label>{{ this.$i18n.t("contract.form.front.label") }}</label>
                      <v-file-input v-model="frontUpload" accept="image/jpeg" :hint="$i18n.t('contract.form.front.hint')"
                        persistent-hint show-size :rules="imageRules" validate-on-blur />
                    </div>
                  </div>
                  <br />
                  <div class="col-form" v-if="isUploading">
                    <div class="col-form__item">
                      <label>{{ this.$i18n.t("contract.form.back.label") }}</label>
                      <v-file-input v-model="backUpload" accept="image/jpeg" :hint="$i18n.t('contract.form.back.hint')"
                        persistent-hint show-size :rules="imageRules" validate-on-blur />
                    </div>
                  </div>
                </div>
                <!-- SERIAL -->
                <div class="row-form">
                  <div class="col-form">
                    <div class="col-form__item">
                      <label>{{ this.$i18n.t("contract.form.serial.label") }}</label>
                      <v-text-field id="form-serial" v-model="serial" :rules="serialRules" validate-on-blur required
                        autocomplete="off" :hint="$i18n.t('contract.form.serial.hint')" persistent-hint />
                    </div>
                  </div>
                </div>
              </v-form>
              <br />
              <v-divider />
              <br />
              <v-row>
                <v-spacer />
                <v-btn :class="{ 'btn-finish': true, }" :disabled="!valid || !validForm" color="primary"
                  @click="saveContract">
                  {{ this.$i18n.t("contract.buttons.sign") }}
                </v-btn>
                <v-spacer />
              </v-row>
            </v-col>
            <v-spacer />
          </v-row>
        </div>
      </div>
    </div>
    <!-- DIALOGS -->
    <v-dialog v-model="progress" persistent width="300">
      <v-card color="primary" dark>
        <div class="ma-2">
          <v-card-text>
            <p>{{ progressMessage }}</p>
            <v-progress-linear indeterminate color="white"></v-progress-linear>
          </v-card-text>
        </div>
      </v-card>
    </v-dialog>
    <v-dialog v-model="errorDialog" :persistent="sendingEmail" width="300">
      <v-card>
        <v-card-text>
          <div class="box-photo text-alert">
            <v-icon color="primary">mdi-alert-circle-outline</v-icon>
            <p>{{ errorMessage }}</p>
          </div>
        </v-card-text>
        <v-divider></v-divider>
        <div class="box-photo text-alert">
          <div v-if="sendingEmail">
            <p>{{ $i18n.t("contract.tooManyAttempts.loading") }}</p>
            <v-progress-linear indeterminate color="primary"></v-progress-linear>
          </div>
          <div v-else>
            <p>{{ $i18n.t("contract.tooManyAttempts.success") }}</p>
          </div>
        </div>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="errorDialog = false">{{ this.$i18n.t("errors.button") }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </section>
</template>

<script>
/* eslint-disable arrow-parens */
export default {
  name: "SimpleContract",
  data() {
    return {
      progress: false,
      camera: false,
      progressMessage: null,
      errorDialog: false,
      errorMessage: null,
      sendingEmail: false,
      attempts: 0,
      valid: false,
      serial: null,
      frontUpload: null,
      backUpload: null,
      frontCamera: null,
      backCamera: null,
      serialRules: [v => !!v || this.$i18n.t("forms.formMustComplete"), v => /(^A{0,1}[0-9]{9})|(^A{0,1}[0-9]{3}\.[0-9]{3}\.[0-9]{3})/.test(v) || this.$i18n.t("contract.form.serial.error")],
      imageRules: [v => (v && v.size < 10485760) || this.$i18n.t("contract.form.front.error")],
      isNewId: true,
      isUploading: true,
      isCameraOpen: true,
      isTakingFront: true,
    };
  },
  computed: {
    selectedIdSide: {
      get() {
        return this.isTakingFront ? this.frontCamera : this.backCamera;
      },
      set(nv) {
        if (this.isTakingFront) {
          this.frontCamera = nv;
        } else {
          this.backCamera = nv;
        }
      },
    },
    validForm() {
      return this.frontUpload && this.backUpload;
    },
  },
  methods: {
    async saveContract() {
      this.progress = true;
      this.progressMessage = this.$i18n.t("contract.signing");
      if (!this.$store.state.session) {
        this.$router.push("/");
        return;
      }
      try {
        const formData = new FormData();
        formData.append("session", JSON.stringify(this.$store.state.session));
        formData.append("email", JSON.stringify(this.$store.state.email));
        formData.append("name", JSON.stringify(this.$store.state.name));
        formData.append("family_name", JSON.stringify(this.$store.state.family_name));
        formData.append("gender", JSON.stringify(this.$store.state.gender));
        formData.append("birthday", JSON.stringify(this.$store.state.birthday));
        formData.append("rut", JSON.stringify(this.$store.state.rut));
        formData.append("nationality", JSON.stringify(this.$store.state.nationality));
        formData.append("birth_country", JSON.stringify(this.$store.state.birth_country));
        formData.append("marital_status", JSON.stringify(this.$store.state.marital_status));
        formData.append("spouse_name", JSON.stringify(this.$store.state.spouse_name));
        formData.append("spouse_family_name", JSON.stringify(this.$store.state.spouse_family_name));
        formData.append("spouse_rut", JSON.stringify(this.$store.state.spouse_rut));
        formData.append("profiling", JSON.stringify(this.$store.state.profiling));
        formData.append("referredFrom", JSON.stringify(this.$store.state.referredFrom));
        formData.append("phone", JSON.stringify(this.$store.state.phone));
        formData.append("street", JSON.stringify(this.$store.state.street));
        formData.append("region", JSON.stringify(this.$store.state.region));
        formData.append("locality", JSON.stringify(this.$store.state.locality));
        formData.append("street_number", JSON.stringify(this.$store.state.street_number));
        formData.append("country", JSON.stringify(this.$store.state.country));
        formData.append("house_type", JSON.stringify(this.$store.state.house_type));
        formData.append("interior_number", JSON.stringify(this.$store.state.interior_number));
        formData.append("isFatca", JSON.stringify(this.$store.state.isFatca));
        formData.append("isCrs", JSON.stringify(this.$store.state.isCrs));
        formData.append("isPep", JSON.stringify(this.$store.state.isPep));
        formData.append("isQualified", JSON.stringify(this.$store.state.isQualified));
        formData.append("isQualifiedOption", JSON.stringify(this.$store.state.isQualifiedOption));
        formData.append("tinValues", JSON.stringify(this.$store.state.tinValues));
        formData.append("isPolitician", JSON.stringify(this.$store.state.isPolitician));
        formData.append("isPoliticianFamily", JSON.stringify(this.$store.state.isPoliticianFamily));
        formData.append("isPoliticianAssociate", JSON.stringify(this.$store.state.isPoliticianAssociate));
        formData.append("serial", JSON.stringify(this.serial));
        formData.append("type", JSON.stringify(true));
        formData.append("front", this.frontUpload);
        formData.append("back", this.backUpload);
        const response = await this.axios.post(`${process.env.VUE_APP_BACKEND}newcontract/sign`, formData, {
          headers: {
            "Access-Control-Allow-Origin": "*",
            "Content-Type": "multipart/form-data",
          },
        });
        if (response.data.code !== 200) {
          this.attempts += 1;
          this.errorMessage = this.$i18n.t(`errors.backend.${response.data.code}`);
          this.progress = false;
          this.errorDialog = true;
          return;
        }
        this.$store.commit("updateUserData", response.data.data);
        this.$store.commit("updateFormStep", { step: 6 });
        this.$router.push("bankform");
        this.progress = false;
      } catch {
        this.attempts += 1;
        this.errorMessage = this.$i18n.t("errors.backend.999");
        this.errorDialog = true;
        this.progress = false;
      }
    },
    async fetchPreview() {
      this.progress = true;
      this.progressMessage = this.$i18n.t("contract.generating");
      try {
        const response = await this.axios.get(`${process.env.VUE_APP_BACKEND}newcontract/preview`, {
          headers: {
            "Access-Control-Allow-Origin": "*",
          },
          responseType: "arraybuffer",
        });
        if (response.data.code && response.data.code !== 200) {
          this.progress = false;
          this.errorMessage = this.$i18n.t(`errors.backend.${response.data.code}`);
          this.errorDialog = true;
          return;
        }
        const blob = new Blob([response.data], { type: "application/pdf" });
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = "contrato.pdf";
        link.click();
        this.progress = false;
      } catch {
        this.progress = false;
        this.errorMessage = this.$i18n.t("errors.backend.999");
        this.errorDialog = true;
      }
    },
  },
};
</script>

<style scoped>
.text-header {
  text-align: center;
}

.text-guide {
  text-align: justify;
}

.text-red {
  color: #d60000;
}

.text-blue {
  color: #0000d6;
}

.text-green {
  color: #00d600;
}

.image-deselected {
  filter: grayscale(100%);
}

.videofeed {
  width: 70vw;
}
</style>
